import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import { Link, useRouteMatch } from 'react-router-dom'
import privacyConstants from 'config/constants/privacy'
import statusThemes from 'config/constants/statusThemes'
import { useOrganization } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const InitiativeStatusBanner = () => {
   const match = useRouteMatch()
   const { organization } = useOrganization()
   const { initiative } = useContext(InitiativeHierarchyContext)

   if (initiative.archived) {
      return (
         <View
            minHeight="60px"
            padding="20px"
            backgroundColor={statusThemes.archived.backgroundColor}
            textAlign="center">
            <Text size="1.5[a-b] 2[c-f]" color="#524439">
               {`This ${initiative.type.nameSingular} is Archived.`}
            </Text>
         </View>
      )
   }

   if (['custom', 'inherit'].includes(initiative.privacy)) {
      return null
   }

   const currentPrivacyOption = privacyConstants.find(p => p.value === initiative.privacy)

   return (
      <View
         minHeight="60px"
         padding="20px 30px"
         backgroundColor={currentPrivacyOption.backgroundColor}
         textAlign="center">
         <Text size="2" color="#524439">
            {/* PRIVATE PRIVACY */}
            {initiative.privacy === 'private' && (
               `This ${initiative.type.nameSingular} is Private. Only people that are invited can see and join this ${initiative.type.nameSingular}.`
            )}
            {/* ADMIN PRIVACY */}
            {initiative.privacy === 'admin' && (
               `This ${initiative.type.nameSingular} is currently in Admin-only Mode. It is only visible to admins of this ${initiative.type.nameSingular} and the ${organization.name} Community.`
            )}
            {/* DRAFT PRIVACY */}
            {initiative.privacy === 'draft' && (
               `This ${initiative.type.nameSingular} is currently a Draft and is only visible to you.`
            )}
            &nbsp;
            {initiative.currentUserCanEdit && (
               <Link to={`${match.url}/settings`}>
                  <u style={{ color: '#524439' }}>
                     <b>Update</b>
                  </u>
               </Link>
            )}
         </Text>
      </View>
   )
}

export default InitiativeStatusBanner
